import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 12.003a9 9 0 0 1-.318-.08c-1.585-.424-2.904-1.246-3.76-2.236-.873-1.008-1.265-2.19-.968-3.3.59-2.201 3.663-3.29 6.863-2.432A8.2 8.2 0 0 1 16.5 5.21M6.42 17.814c.857.99 2.176 1.812 3.761 2.236 3.2.858 6.274-.23 6.863-2.431.233-.868.044-1.779-.465-2.616m-12.83-3h16.5"
    }, null, -1)
  ])))
}
export default { render: render }